export default __webpack_public_path__ + "static-front/media/UsersIcon.070f9e14.svg";